import React from 'react';
import withAuthentication from '../../containers/Authentication/withAuthentication';
import { withTranslation } from 'react-i18next';
import FullPagePaper from '../../components-soapy/FullPagePaper'
import GroupsTableHeader from './GroupsTableHeader'
import GroupsTable from './GroupsTable';
import groups from './Groupdata';

// -------------------------Groups Container------------------------//
const GroupsContainer = () => {
  return (
    <FullPagePaper>
      <GroupsTableHeader totalGroups={100} />
      <GroupsTable groups={groups} />
    </FullPagePaper>
  );
};

export default withAuthentication(withTranslation()(GroupsContainer));
